import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, inject } from '@angular/core';
import { MixedResultType, ResultStatusEnum } from '@campus/dal';
import { MixedResultWithActionsInterface } from '../../interfaces';
import '@diekeure/dcr-components/dcr-list-item.js';
import '@diekeure/dcr-components/dcr-plain-tooltip.js';
import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-menu.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-inline-icon-button.js';
import '@diekeure/dcr-components/dcr-tonal-button.js';

@Component({
  standalone: false,
  selector: 'campus-edu-content-result-list-item',
  templateUrl: './edu-content-result-list-item.component.html',

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EduContentResultListItemComponent {
  element = inject(ElementRef).nativeElement;

  ResultStatusEnum: typeof ResultStatusEnum = ResultStatusEnum;

  @HostBinding('class')
  defaultClasses = ['block'];

  @HostBinding('class.cursor-pointer')
  get hasAttempts() {
    return this.mixedResult?.attempts?.length > 1;
  }

  @Input() mixedResult: MixedResultWithActionsInterface<MixedResultType>;
}
